import { createFileRoute } from '@tanstack/react-router';
import { DonationPage } from '@/components/donations';
import { SUBSIDIARY_CODE } from '@/config';

// Public, UNAUTHENTICATED donor donation page — NEUTRAL URL (no subsidiary segment).
// Each subsidiary is its own origin/build, so the subsidiary comes from THIS build
// (SUBSIDIARY_CODE), not the URL, and rides the X-Subsidiary header on the donor API
// calls (ADR-052). The legacy /$subsidiary/donate/$slug route is retained for
// already-shared links and single-origin local dev.
export const Route = createFileRoute('/donate/$slug')({
  component: DonationRoute,
});

function DonationRoute() {
  const { slug } = Route.useParams();
  return <DonationPage subsidiary={SUBSIDIARY_CODE} slug={slug} />;
}
